import script from "./OrganizationTeam.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationTeam.vue?vue&type=script&setup=true&lang=js"

import "./OrganizationTeam.vue?vue&type=style&index=0&id=0bc10180&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bc10180"]])

export default __exports__